import { render, staticRenderFns } from "./DeleteSlideDialog.vue?vue&type=template&id=5bb62e4c&"
import script from "./DeleteSlideDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteSlideDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports